import { PropsWithChildren } from 'react';
import { Handle, Position } from '@xyflow/react';
import { NodeConnection } from '@lp/features/RoutePlanner/types';

export const NodeHandleConnections = ({ children }: PropsWithChildren) => (
  <>
    <Handle type="target" position={Position.Left} id={NodeConnection.toMainLeft} className="opacity-0" isConnectable />
    <Handle
      type="source"
      position={Position.Left}
      id={NodeConnection.fromMainLeft}
      className="opacity-0"
      isConnectable
    />
    <Handle
      type="target"
      position={Position.Top}
      id={NodeConnection.toLeft}
      className="opacity-0 left-4!"
      isConnectable
    />
    <Handle type="target" position={Position.Top} id={NodeConnection.toCenter} className="opacity-0" isConnectable />
    <Handle
      type="target"
      position={Position.Top}
      id={NodeConnection.toRight}
      className="opacity-0 right-4! left-[unset]! translate-x-1/2 -translate-y-1/2 transform-[unset]!"
      isConnectable
    />
    {children}
    <Handle
      type="target"
      position={Position.Right}
      id={NodeConnection.toMainRight}
      className="opacity-0"
      isConnectable
    />
    <Handle
      type="source"
      position={Position.Right}
      id={NodeConnection.fromMainRight}
      className="opacity-0"
      isConnectable
    />
    <Handle
      type="source"
      position={Position.Bottom}
      id={NodeConnection.fromLeft}
      className="opacity-0 left-4!"
      isConnectable
    />
    <Handle
      type="source"
      position={Position.Bottom}
      id={NodeConnection.fromCenter}
      className="opacity-0"
      isConnectable
    />
    <Handle
      type="source"
      position={Position.Bottom}
      id={NodeConnection.fromRight}
      className="opacity-0 right-4! left-auto!"
      isConnectable
    />
  </>
);
